import React, { useMemo } from "react";
import MultiSelect from "src/business-types/grocery/components/MultiSelect";
import { StaffMember } from "src/shared/services/interfacev2";

interface StaffSelectProps {
  staffMembers: StaffMember[];
  value?: string[];
  onChange: (value: string[]) => void;
  label?: string;
}

const StaffSelect: React.FC<StaffSelectProps> = ({ staffMembers, value = [], onChange, label = "Assign Staff Members" }) => {
  // Helper to build full name
  const getFullName = (staff: StaffMember) => [staff.firstName, staff.middleName, staff.lastName].filter(Boolean).join(" ");

  // Convert staffMembers to MultiSelect options
  const options = useMemo(
    () =>
      staffMembers.map((staff) => ({
        _id: staff._id.$oid,
        CategoryName: getFullName(staff),
      })),
    [staffMembers]
  );

  return <MultiSelect title={label} name="staffMembers" options={options} value={value} onChange={onChange} />;
};

export default StaffSelect;
